import { api } from '@/apis';
import { log } from '@/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteObjective() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => {
      if (id) {
        log('Delete', 'Objective', { id });

        return api.delete(`objectives/${id}`);
      }
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['objectives'] }),
  });
}
